import type { InputHTMLAttributes } from 'react'

interface FormFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  error?: string
  hint?: string
}

export function FormField({ label, error, hint, ...inputProps }: FormFieldProps) {
  return (
    <div>
      <label className='field-label'>{label}</label>
      <input
        {...inputProps}
        className={`field-input${error ? ' error' : ''}`}
      />
      {error && (
        <div style={{ font: '400 11.5px Inter,sans-serif', color: '#E0663B', marginTop: 5 }}>
          {error}
        </div>
      )}
      {!error && hint && (
        <div style={{ font: '400 11.5px Inter,sans-serif', color: 'rgba(27,42,74,0.45)', marginTop: 5 }}>
          {hint}
        </div>
      )}
    </div>
  )
}
